import React from "react";
import CardAuto from "./CardAuto.js";
import Header from "./HeaderAuto.js";

const Auto = () => {
  return (
    <div>
      <Header></Header>
      <CardAuto></CardAuto>
    </div>
  );
};

export default Auto;
